import { render, staticRenderFns } from "./AiMyprCompanyUrlField.vue?vue&type=template&id=c20f484e"
import script from "./AiMyprCompanyUrlField.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiMyprCompanyUrlField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports